/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
  AsyncResult,
  callActionOrExecute,
  DataServiceQuery,
  IContext,
  IDataServiceRequest,
  IQueryResultSettings,
} from "@msdyn365-commerce/retail-proxy";
// @ts-ignore
import * as EntityClasses from "@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g";
import * as DataServiceEntities from "./DataServiceEntities.g";

function getShiptrackTrackingNumberQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getShiptrackTrackingNumberInput(
  salesOrderNum: string
): IDataServiceRequest {
  const query = getShiptrackTrackingNumberQuery();
  return query.createDataServiceRequestForOperation(
    "GetShiptrackTrackingNumber",
    true,
    DataServiceEntities.ShipmentTrackingLinesExtensionClass,
    "false",
    {
      bypassCache: "get",
      returnEntity: "DataServiceEntities.IShipmentTrackingLines",
    },
    {
      salesOrderNum: salesOrderNum,
    }
  );
}

export function getShiptrackTrackingNumberAsync(
  context: IContext,
  salesOrderNum: string
): AsyncResult<DataServiceEntities.IShipmentTrackingLines> {
  const request = getShiptrackTrackingNumberInput(salesOrderNum);
  return callActionOrExecute<DataServiceEntities.IShipmentTrackingLines>(
    request,
    context.callerContext
  );
}

function getProductsReferenceNumberQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getProductsReferenceNumberInput(
  queryResultSettings: IQueryResultSettings,
  productIds: number[]
): IDataServiceRequest {
  const query =
    getProductsReferenceNumberQuery().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    "GetProductsReferenceNumber",
    true,
    DataServiceEntities.ProductReferenceNumberExtensionClass,
    "true",
    {
      bypassCache: "get",
      returnEntity: "DataServiceEntities.IProductReferenceNumber",
    },
    {
      productIds: productIds,
    }
  );
}

export function getProductsReferenceNumberAsync(
  context: IContext,
  productIds: number[]
): AsyncResult<DataServiceEntities.IProductReferenceNumber[]> {
  const request = getProductsReferenceNumberInput(
    context.queryResultSettings || {},
    productIds
  );
  return callActionOrExecute<DataServiceEntities.IProductReferenceNumber[]>(
    request,
    context.callerContext
  );
}

function customerInvoiceInquiryQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function customerInvoiceInquiryInput(
  invoiceId: string,
  customerId: string,
  reason: string,
  comment: string,
  emailAddress: string
): IDataServiceRequest {
  const query = customerInvoiceInquiryQuery();
  return query.createDataServiceRequestForOperation(
    "CustomerInvoiceInquiry",
    true,
    DataServiceEntities.InvoiceInquiryResultExtensionClass,
    "false",
    {
      bypassCache: "get",
      returnEntity: "DataServiceEntities.IInvoiceInquiryResult",
    },
    {
      invoiceId: invoiceId,
      customerId: customerId,
      reason: reason,
      comment: comment,
      emailAddress: emailAddress,
    }
  );
}

export function customerInvoiceInquiryAsync(
  context: IContext,
  invoiceId: string,
  customerId: string,
  reason: string,
  comment: string,
  emailAddress: string
): AsyncResult<DataServiceEntities.IInvoiceInquiryResult> {
  const request = customerInvoiceInquiryInput(
    invoiceId,
    customerId,
    reason,
    comment,
    emailAddress
  );
  return callActionOrExecute<DataServiceEntities.IInvoiceInquiryResult>(
    request,
    context.callerContext
  );
}
